import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Renders an anchor icon
 * @see SvgIcon for propTypes
 *
 * @example
 * <AnchorIcon width={12} />
 */
const AnchorIcon = props => (
    <SvgIcon viewBox="0 0 18 18" {...props}>
        <path d="M4,11.5l5-5,5,5H4Z" />
    </SvgIcon>
)

export { AnchorIcon }
